import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import UsersContent from './UsersContent'
export default class Users extends Component {

    render() {
        let page = this.props.match.params.page;


        const urlParams = new URLSearchParams(window.location.search);

        
        return (
            <div className="wrapper">

                <Navbar />
                <Mainmenu />
                <UsersContent page={page} urlParams={urlParams} />
                <Footer />

            </div>


        )
    }
}
